export default __webpack_public_path__ + "static/media/flash08.595e2d0a.png";